import React from 'react';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PhotoContainer from './PhotoContainer';
import logo from '../assets/logo.svg';

const Header = ({ profile, location, isAuthenticated }) => {
  const title = profile && profile.name;

  return (
    <div className="header">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>
      </div>
      <div className="links">
        <div className={`${location.pathname === '/' && 'selected'}`}>
          <Link to="/">Dashboard</Link>
        </div>
        <div
          className={`${
            location.pathname.indexOf('/teams') > -1 && 'selected'
          }`}
        >
          <Link to="/teams">Teams</Link>
        </div>
        <div
          className={`${
            (location.pathname.indexOf('/agreements') > -1 ||
              location.pathname.indexOf('/dealroom') > -1) &&
            'selected'
          }`}
        >
          <Link to="/agreements">Agreements</Link>
        </div>
        <div
          className={`${
            (location.pathname.indexOf('/copyright-reg-list') > -1 ||
              location.pathname.indexOf('/copyright-reg-list') > -1) &&
            'selected'
          }`}
        >
          <Link to="/copyright-reg-list">Copyright Registrations</Link>
        </div>
        <div>
          <a href="https://cosynd.zendesk.com" target="_blank">
            Help
          </a>
        </div>
        <div>
          <a
            href="https://cosynd.zendesk.com/hc/en-us/requests/new"
            target="_blank"
          >
            Report An Issue
          </a>
        </div>
      </div>
      {isAuthenticated ? (
        <div className="user">
          <div className="user-img">
            <PhotoContainer
              className="photo-container"
              image={profile.avatar}
              defaultImg="user"
            />
          </div>
          <div className="menu">
            <DropdownButton pullRight bsStyle="link" title="" id="usermenu">
              <MenuItem eventKey="1" disabled>
                Welcome {title}!
              </MenuItem>
              <MenuItem divider />
              <MenuItem eventKey="2" href="/user">
                Edit profile
              </MenuItem>
              <MenuItem eventKey="3" href="/password">
                Change Password
              </MenuItem>
              <MenuItem divider />
              <MenuItem eventKey="9" href="/logout">
                Logout
              </MenuItem>
            </DropdownButton>
          </div>
        </div>
      ) : (
        <div className="user" />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  profile: state.profile,
});

export default connect(mapStateToProps)(withRouter(Header));



// WEBPACK FOOTER //
// src/components/Header.jsx